import axios from "axios";
import { extractData, handleApiException, handleResponse } from "helpers/apiResponseHelper";
import { apiService } from "services/api.service";

export enum ApartmentAgreementStatus {
  ACTIVE = "ACTIVE",
  ENDED = "ENDED",
  CANCELED = "CANCELED",
}

export interface ApartmentAgreement {
  id: number;
  agreementId: number;
  customerId: number;
  customerName?: string;
  name: string;
  startDate: string;
  endDate?: string;
  status: ApartmentAgreementStatus;
  dateCreated: string;
  dateModified?: string;
}

export interface CreateApartmentAgreementRequest {
  agreementId: number;
  name: string;
  startDate: string;
  endDate?: string;
  customerId?: number;
  personalIdentificationCode?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
}

export interface RenameApartmentAgreementRequest {
  name: string;
}

export interface ChangeApartmentCustomerRequest {
  customerId?: number;
  personalIdentificationCode?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  name?: string;
  startDate: string;
  endDate?: string;
}

export interface EndApartmentAgreementRequest {
  endDate: string;
}

const BASE_PATH = "/electricity/apartment-agreements/admin";

async function create(request: CreateApartmentAgreementRequest): Promise<ApartmentAgreement> {
  return axios
    .post(apiService.getApiUrl() + BASE_PATH, request)
    .then(handleResponse)
    .then(extractData)
    .catch(handleApiException);
}

async function rename(id: number, request: RenameApartmentAgreementRequest): Promise<ApartmentAgreement> {
  return axios
    .patch(apiService.getApiUrl() + `${BASE_PATH}/${id}/name`, request)
    .then(handleResponse)
    .then(extractData)
    .catch(handleApiException);
}

async function changeCustomer(id: number, request: ChangeApartmentCustomerRequest): Promise<ApartmentAgreement> {
  return axios
    .post(apiService.getApiUrl() + `${BASE_PATH}/${id}/change-customer`, request)
    .then(handleResponse)
    .then(extractData)
    .catch(handleApiException);
}

async function cancel(id: number): Promise<ApartmentAgreement> {
  return axios
    .post(apiService.getApiUrl() + `${BASE_PATH}/${id}/cancel`)
    .then(handleResponse)
    .then(extractData)
    .catch(handleApiException);
}

async function setEndDate(id: number, request: EndApartmentAgreementRequest): Promise<ApartmentAgreement> {
  return axios
    .patch(apiService.getApiUrl() + `${BASE_PATH}/${id}/end-date`, request)
    .then(handleResponse)
    .then(extractData)
    .catch(handleApiException);
}

async function listByAgreementId(
  agreementId: number,
  includeHistory = false
): Promise<ApartmentAgreement[]> {
  return axios
    .get(apiService.getApiUrl() + `${BASE_PATH}/agreement/${agreementId}`, {
      params: { includeHistory },
    })
    .then(handleResponse)
    .then(extractData)
    .catch(handleApiException);
}

async function getById(id: number): Promise<ApartmentAgreement> {
  return axios
    .get(apiService.getApiUrl() + `${BASE_PATH}/${id}`)
    .then(handleResponse)
    .then(extractData)
    .catch(handleApiException);
}

const ElectricityApartmentAgreementsService = {
  create,
  rename,
  changeCustomer,
  cancel,
  setEndDate,
  listByAgreementId,
  getById,
};

export default ElectricityApartmentAgreementsService;
